<template>
  <div>
    <b-card>
      <b-row class="justify-content-end mx-25">
        <div v-can="{ slug: $route.meta.instructionsSlug, action: 'C' }">
          <b-button
            variant="success d-flex align-items-center"
            @click="
              onNewClicked();
              isEdit = false;
            "
          >
            <feather-icon size="18" icon="PlusIcon" />
            <span class="mx-25"> إضافة </span>
          </b-button>
        </div>
      </b-row>
      <hr />
      <data-table
        v-can="{ slug: $route.meta.instructionsSlug, action: 'S' }"
        :fields="fields"
        ep="v2/financial/annual-budgets"
        dataPath="data"
        ref="financialDataTable"
      >
        <template #cell(final_budget)="{ value }">
          {{ new Intl.NumberFormat().format(value) }}
          ل.س
        </template>
        <template #cell(next_year_budget)="{ value }">
          {{ new Intl.NumberFormat().format(value) }}
          ل.س
        </template>
        <template #cell(src)="{ value }">
          <router-link
            rel="noopener noreferrer"
            :to="{ name: 'file-view', query: { ep: value } }"
            target="_blank"
          >
            عرض الملف</router-link
          >
        </template>
        <template #cell(actions)="{ item }">
          <div class="d-flex justify-content-end">
            <b-button
              v-can="{ slug: $route.meta.instructionsSlug, action: 'D' }"
              size="sm"
              @click="onDeleteClicked(item.id)"
              variant="flat-danger"
              class="btn-icon rounded-circle"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
            <b-button
              v-can="{ slug: $route.meta.instructionsSlug, action: 'U' }"
              size="sm"
              @click="
                onEditClicked(item);
                isEdit = true;
              "
              variant="flat-info"
              class="btn-icon rounded-circle"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
          </div>
        </template>
      </data-table>
      <form-modal
        v-model="isFormShown"
        :formSchema="formSchema"
        :loading="working"
        ref="financialDataForm"
        title="معلومات الموازنة"
        @confirm="onModalConfirmed"
        static
      >
        <template #src="{ form }">
          <!-- <label for="document">وثيقة الموازنة</label> -->
          <!-- <b-form-file
            browse-text="تصفح"
            placeholder="اختر ملفاً"
            id="document"
            accept=".pdf"
            v-model="form.src"
          /> -->
          <form-file-input
            placeholder="اختر ملفاً"
            id="document"
            label="وثيقة الموازنة"
            accept=".doc,.pdf,.docx"
            v-model="form.src"
            :key="isFormShown"
          />
        </template>
        <template #final_budget="{ form }">
          <form-currency
            label="الميزانية الختامية"
            v-model="form.final_budget"
            rules="required"
          />
        </template>
        <template #next_year_budget="{ form }">
          <form-currency
            label="الموازنة التقديرية للعام القادم"
            v-model="form.next_year_budget"
            rules="required"
          />
        </template>
      </form-modal>
    </b-card>
  </div>
</template>

<script>
import { BCard, BRow, BCol, BFormFile, BButton } from "bootstrap-vue";
import DataTable from "@/components/data-table";
import FormModal from "@/components/FormModal.vue";
import FormCleave from "@/components/FormCleave.vue";
import FormCurrency from "@/components/FormCurrency.vue";
import FormFileInput from "@/components/FormFileInput.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    DataTable,
    BCard,
    BRow,
    BCol,
    BFormFile,
    BButton,
    FormModal,
    FormCleave,
    FormCurrency,
    FormFileInput,
  },
  data() {
    return {
      isFormShown: false,
      isEdit: false,
      fields: [
        {
          key: "id",
          label: "المعرف",
        },
        {
          key: "year",
          label: "السنة",
        },
        {
          key: "final_budget",
          label: "الميزانية الختامية",
        },
        {
          key: "next_year_budget",
          label: "الموازنة التقديرية للعام القادم",
        },
        {
          key: "src",
          label: "وثيقة الموازنة",
        },
        {
          key: "actions",
          label: " ",
        },
      ],
      formSchema: {
        year: {
          component: "FormSelect",
          key: "year",
          attrs: {
            id: "year",
            label: "السنة",
            rules: "required",
            options: this.getYears(),
          },
        },
        final_budget: {
          key: "final_budget",
        },
        next_year_budget: {
          key: "next_year_budget",
        },
        src: {
          key: "src",
        },
      },
    };
  },
  computed: {
    ...mapGetters("Financial", ["working"]),
  },
  methods: {
    ...mapActions("Financial", [
      "editFinancialData",
      "addFinancialData",
      "deleteFinancialData",
    ]),
    getYears() {
      var x = [];
      for (let index = 1950; index < this.$moment().year(); index++) {
        x.push(`${index}`);
      }
      return x.reverse();
    },
    onDeleteClicked(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف المستند ؟", {
          title: "تأكيد حذف المستند",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            await this.deleteFinancialData(id).then(() => {
              this.$refs.financialDataTable.refreshTable();
            });
          }
        });
    },
    onEditClicked(form) {
      this.$refs.financialDataForm.init({
        id: form.id,
        year: form.year,
        final_budget: form.final_budget,
        next_year_budget: form.next_year_budget,
        src: form.src,
      });
      this.isFormShown = true;
    },
    async onModalConfirmed(form) {
      const toUpdate = { ...form };
      if (toUpdate.id) {
        if (typeof toUpdate.src === "string") delete toUpdate.src;
        await this.editFinancialData(toUpdate);
      } else await this.addFinancialData(toUpdate);
      this.isFormShown = false;
      this.$refs.financialDataTable.refreshTable();
    },
    onNewClicked() {
      this.$refs.financialDataForm.init({});
      this.isFormShown = true;
    },
  },
};
</script>
